export const MOCK_SSL_RESPONSE = {
  results: [
    {
      id: 'mock-ssl-1',
      host: 'example.com',
      score: 'A',
      certificate_status: true,
      days_to_expiry: 245,
      timestamp: '2024-11-15T09:45:00Z',
      timestamp_jalali: '1403/08/25 09:45',
    },
    {
      id: 'mock-ssl-2',
      host: 'api.example.com',
      score: 'B',
      certificate_status: true,
      days_to_expiry: 18,
      timestamp: '2024-11-15T09:50:00Z',
      timestamp_jalali: '1403/08/25 09:50',
    },
    {
      id: 'mock-ssl-3',
      host: 'legacy.example.com',
      score: 'F',
      certificate_status: false,
      days_to_expiry: 0,
      timestamp: '2024-11-15T09:55:00Z',
      timestamp_jalali: '1403/08/25 09:55',
    },
  ],
  current_page: 1,
  total_pages: 1,
}

export const MOCK_SSL_FILTER_OPTIONS = {
  score: ['A', 'B', 'C', 'D', 'F'],
  certificate_status: [true, false],
}

export const MOCK_SSL_DETAIL = {
  host: 'example.com',
  data: {
    rating: [
      { finding: 'Certificate' },
      { finding: 'Protocol Support' },
      { finding: 'Key Exchange' },
      { finding: 'A' },
    ],
    info: [
      { finding: 'TLS 1.2, TLS 1.3' },
      { finding: 'RSA 2048 bits' },
    ],
    report: [
      {
        title: 'Certificate',
        detail: [
          { title: 'Subject', finding: 'CN=example.com' },
          { title: 'Issuer', finding: "Let's Encrypt Authority X3" },
          { title: 'Expiry', finding: '2025-08-15' },
          { title: 'Key Size', finding: '2048 bits (RSA)' },
        ],
      },
      {
        title: 'Protocol Support',
        detail: [
          { title: 'TLS 1.3', finding: 'Yes' },
          { title: 'TLS 1.2', finding: 'Yes' },
          { title: 'TLS 1.1', finding: 'No' },
          { title: 'TLS 1.0', finding: 'No' },
        ],
      },
      {
        title: 'Cipher Suites',
        detail: [
          { title: 'TLS_AES_256_GCM_SHA384', finding: 'Enabled' },
          { title: 'TLS_CHACHA20_POLY1305_SHA256', finding: 'Enabled' },
        ],
      },
    ],
  },
}
